/**
 * @file UI 常量
 * @author malcolmmzma
 */

export const ICONS = {
  INDEX_BACKGROUND: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/1750239695083.png?max_age=31536000',
  AGENT_NAME_ICON: 'https://qzonestyle.gdtimg.com/gdt_ui_proj/imghub/dist/silicon-assistant-ui-inline-logo.svg?max_age=31536000',
};

export const COPYRIGHT_TEXT = '内容由AI生成，仅供参考';
